import { render, staticRenderFns } from "./DeleteCarrierSimCardsToInventory.vue?vue&type=template&id=954589ea&"
import script from "./DeleteCarrierSimCardsToInventory.vue?vue&type=script&lang=js&"
export * from "./DeleteCarrierSimCardsToInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports